export interface ApiEnvelope<T> {
  success: boolean
  code: number
  message: string
  messageCode: string
  data?: T
  pagination?: { page: number; size: number; total: number }
}

export class ApiError extends Error {
  constructor(public readonly status: number, message: string, public readonly code?: string) {
    super(message)
    this.name = 'ApiError'
  }
}
